<template>
  <div class="cloud_shop" id="cloud_shop">
    <div class="submit_success" v-if="commitStatus">
      <div class="prompt">
        <span>您已提交申请！</span>
        <img src="../../../static/imgs/VXImage/right_icon.svg" />
      </div>
      <div class="prompt_text">请耐心等待，客户经理会第一时间联系您！</div>
      <img src="../../../static/imgs/submit_success.svg" alt="" />
      <div class="cs_form_submit" @click="prev">返回</div>
    </div>
    <div class="cloud_shop_content" v-else>
      <div class="cloud_shop_title">
        <div class="cs_title">欢迎定制私人报告</div>
        <div class="cs_tab"></div>
        <img
          class="cs_img"
          src="../../../static/imgs/VXImage/report.svg"
          alt=""
        />
      </div>
      <div class="cs_form">
        <div class="cs_form_content">
          <div class="cs_form_icon">
            <img src="../../../static/imgs/cs_name.svg" alt="" />
            <span>您的姓名：</span>
          </div>
          <div
            :class="error3 ? 'cs_form_inp cs_form_inp_error' : 'cs_form_inp'"
          >
            <input
              type="text"
              placeholder="请输入姓名"
              v-model="name"
              @input="write(3)"
            />
          </div>
          <p class="cs_form_error" v-if="error3">请输入正确姓名</p>
        </div>
        <div class="cs_form_content">
          <div class="cs_form_icon">
            <img
              src="../../../static/imgs/VXImage/cross_border_icon.svg"
              alt=""
            />
            <span>是否有过跨境经验：</span>
          </div>
          <div class="cs_form_inp">
            <select v-model="exp" placeholder="请选择">
              <option value="是">是</option>
              <option value="否">否</option>
            </select>
          </div>
        </div>
        <div class="cs_form_content">
          <div class="cs_form_icon">
            <img src="../../../static/imgs/cs_phone.svg" alt="" />
            <span>您的手机号码：</span>
          </div>
          <div
            :class="error1 ? 'cs_form_inp cs_form_inp_error' : 'cs_form_inp'"
          >
            <input
              type="number"
              placeholder="请输入手机号码"
              v-model="telephone"
              @input="write(1)"
            />
          </div>
          <p class="cs_form_error" v-if="error1">{{ phoneError }}</p>
        </div>
        <div class="cs_form_submit" @click="submit()">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "privateReport",
  data() {
    return {
      exp: "否",
      telephone: "",
      name: "",
      error1: false,
      error3: false,
      commitStatus: false,
      phoneError: "请输入正确手机号码",
    };
  },
  methods: {
    write(index) {
      if (index == 1) {
        this.error1 = false;
      } else if (index == 3) {
        this.error3 = false;
      }
    },
    submit() {
      let flag = true;
      let reg =
        /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;
      if (this.telephone == "" || !reg.test(this.telephone)) {
        this.phoneError = "请输入正确手机号码";
        this.error1 = true;
        flag = false;
      }
      if (!this.name) {
        this.error3 = true;
        flag = false;
      }
      if (flag) {
        this.$axios
          .get(
            `https://gateway.antdiy.vip/website-saleswing-service/chat/7871cb70c83158c04c3ea2ab23f1f373dd4dd957c717345110ccfc51516c3740`,
            {
              params: {
                message: `有新客户定制私人报告！ \n客户姓名：${this.name} \n是否有跨境经验：${this.exp} \n手机号：${this.telephone}`,
              },
            }
          )
          .then((res) => {
            this.commitStatus = true;
          });
      }
    },
    prev() {
      // this.$router.go(-1);
      if (typeof WeixinJSBridge != "undefined") {
        WeixinJSBridge.call("closeWindow");
      } else {
        if (navigator.userAgent.indexOf("MSIE") > 0) {
          if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
            window.opener = null;
            window.close();
          } else {
            window.open("", "_top");
            window.top.close();
          }
        } else if (navigator.userAgent.indexOf("Firefox") > 0) {
          window.location.href = "about:blank ";
        } else {
          window.opener = null;
          window.open("", "_self", "");
          window.close();
        }
      }
    },
  },
  created() {},
};
</script>
<style scoped>
.cloud_shop {
  width: 100%;
  padding: 0.5rem 0.18rem;
  max-width: 640px;
  margin: 0 auto;
}
.submit_success {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.prompt {
  font-family: SourceHanSansCN-Bold;
  font-size: 0.4rem;
  color: #fc5322;
  letter-spacing: 0;
  font-weight: 700;
  margin: 2.5rem 0 0.23rem;
  display: flex;
  align-items: center;
}
.prompt_text {
  font-family: SourceHanSansCN-Regular;
  font-size: 0.28rem;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 0.42rem;
  font-weight: 400;
}
.submit_success img {
  width: 100%;
  margin: 0.66rem 0 0.65rem;
}
.prompt img{
  width: .35rem !important;
  margin: 0 !important;
}
.cloud_shop_content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.cloud_shop_title {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.cs_title {
  font-family: SourceHanSansCN-Bold;
  font-size: 0.4rem;
  color: #222536;
  letter-spacing: 0.0056rem;
  text-align: center;
  font-weight: 700;
}
.cs_tab {
  width: 0.6rem;
  height: 0.08rem;
  background: #fc5421;
  border-radius: 0.06rem;
  margin: 0.3rem 0 0.16rem;
}
.cs_img {
  width: 100%;
}
.cs_introduce {
  font-family: SourceHanSansCN-Bold;
  font-size: 0.32rem;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 0.46rem;
  font-weight: 700;
  margin-bottom: 0.34rem;
}
.cs_text {
  font-family: SourceHanSansCN-Regular;
  font-size: 0.2rem;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 0.3rem;
  font-weight: 400;
}
.cs_text p:last-child {
  margin-top: 0.25rem;
}
.cs_form {
  width: 100%;
  margin-top: 0.54rem;
  padding: 0 0.3rem;
}
.cs_form_content {
  width: 100%;
  margin-bottom: 0.33rem;
}
.cs_form_icon {
  display: flex;
  align-items: center;
  margin-bottom: 0.2rem;
}
.cs_form_icon img {
  height: 0.32rem;
  margin-right: 0.12rem;
}
.cs_form_icon span {
  font-family: SourceHanSansCN-Medium;
  font-size: 0.28rem;
  color: #222536;
  letter-spacing: 0;
  font-weight: 500;
}
.cs_form_inp {
  width: 100%;
  display: flex;
}
.cs_form_inp input,
.cs_form_inp select {
  flex: 1;
  height: 0.83rem;
  background: rgba(245, 247, 252, 0);
  border: 0.01rem solid rgba(151, 151, 151, 0.5);
  border-radius: 0.08rem;
  padding: 0 0.23rem;
  font-size: 0.28rem;
  letter-spacing: 0;
  text-align: justify;
  font-weight: 400;
}
.cs_form_inp input::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.29);
}
.cs_form_inp input:-moz-placeholder {
  color: rgba(0, 0, 0, 0.29);
}
.cs_form_inp input:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.29);
}
.cs_form_inp_error input {
  border: 0.02rem solid rgba(255, 39, 39, 1);
  border-radius: 0.08rem;
}
.cs_form_inp .cs_form_button {
  width: 2.2rem;
  height: 0.83rem;
  margin-left: 0.1rem;
  background: rgba(238, 238, 238, 0.65);
  border: 0.01rem solid rgba(151, 151, 151, 0.5);
  border-radius: 0.08rem;
  font-family: SourceHanSansCN-Regular;
  font-size: 0.28rem;
  color: #b6b6b6;
  letter-spacing: 0;
  text-align: justify;
  font-weight: 400;
  text-align: center;
  line-height: 0.83rem;
}
.cs_form_submit {
  width: 100%;
  background: #fc5322;
  box-shadow: 0rem 0.06rem 0.08rem 0rem rgba(252, 83, 34, 0.1);
  border-radius: 0.08rem;
  height: 0.74rem;
  font-family: SourceHanSansCN-Medium;
  font-size: 0.28rem;
  color: #ffffff;
  letter-spacing: 0.0088rem;
  font-weight: 500;
  line-height: 0.74rem;
  text-align: center;
}
.cs_form_submit:active {
  background: #e34a1e;
}
.cs_form_error {
  font-family: SourceHanSansCN-Regular;
  font-size: 0.2rem;
  color: #ff2727;
  letter-spacing: 0;
  text-align: justify;
  font-weight: 400;
  margin-top: 0.12rem;
}
</style>



// WEBPACK FOOTER //
// src/components/VXPublicAcount/privateReport.vue